import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { worklowData } from '../data/data';
import { AdditionalCostDialogComponent } from '../../main/questions/dialogs/additional-cost-dialog/additional-cost-dialog.component';
import { DataDialogService } from 'app/main/questions/dialogs/data-dialog/data-dialog.service';
import { Step } from '@models/step.model';
import { Section } from '@models/section.model';
import { Pages } from '@enums/pages-enum';
import { SectionData } from '@models/section-data.model';
import { ConfirmDialogComponent } from 'app/main/questions/dialogs/confirm-dialog/confirm-dialog.component';
import { DataDialogComponent } from 'app/main/questions/dialogs/data-dialog/data-dialog.component';
import { AppQuestionData } from '@models/app-question-data';
import { Representatives } from '@enums/representatives-enum';
import { DataValueType } from '@enums/data-value-type-enum';
import { CustomDialogComponent } from 'app/main/questions/dialogs/custom-dialog/custom-dialog.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { HbfStylesModel } from '@models/hbf-styles-model';
import { Observable, Subject } from 'rxjs';
import { SummaryService } from 'app/main/questions/summary/summary.service';
import { ActionsTypeEnum } from '@enums/actions-type-enum';


@Injectable()
export class WorkflowService {

    private _showSMSDialog: boolean = false;
    steps: Array<Step>;
    currentSection: Section;
    currentStep: Step;
    prevStep: Step;
    loading = false;
    showSuccessPage = true;
    private _nextLocked: boolean = false;
    private encryptedIdService: string;
    private layoutStyles = new Subject<HbfStylesModel>();

    private serviceState = new Subject<number>();
    serviceState$ = this.serviceState.asObservable();
    
    constructor(
        private router: Router,
        private dialog: MatDialog,
        private confirmDialog: MatDialog,
        private dataDialogService: DataDialogService,
        private summaryService: SummaryService) {

        if (localStorage.getItem('steps')) {
            this.parseStepsData();
        }
        else {
            this.fetchData();
        }

        if (this.currentStep && this.currentStep.url !== router.url) {
            if (this.router.url.includes('/home/taken-service')) {
                this.currentStep = this.getStep(Pages.TAKEN_SERVICE);
            } else {
                this.router.navigate([this.currentStep.url]);
            }
        }
    }

    // get showSmsDialog() {
    //     return this._showSMSDialog;
    // }

    // set showSmsDialog(val: boolean) {
    //     this._showSMSDialog = val;
    //     localStorage.setItem('smsDialog', val === true ? 'true' : 'false');
    // }

    verifyShowSmsDialog(): boolean {
        let result = false;
        this.steps.every(s => {
            if (s.sectionData.GetSmsDialog()) {
                result = true;
                // this end the loop
                return false;
            }
            // this continues the loop
            return true;
        });
        return result;
    }

    get companyId() {
        return localStorage.getItem('companyId') ?? '0';
    }

    private parseStepsData() {
        this.steps = worklowData;
        const cachedSteps = JSON.parse(localStorage.getItem('steps'));
        this.steps.forEach(step => {
            const cachedStep = cachedSteps.find(x => x.Id === step.Id);
            step.active = cachedStep.active;
            step.sectionData = new SectionData();
            step.sectionData.SetAllProperties(cachedStep.sectionData.properties);
            step.sectionData.SetAppQuestionData(cachedStep.sectionData.appQuestionData);
            step.sectionData.SetResume(cachedStep.sectionData.resume);
            step.sectionData.SetSmsDialog(cachedStep.sectionData.showSmsDialog);
        });
        this.currentStep = this.getStep(JSON.parse(localStorage.getItem('currentStep')).Id);
        this.prevStep = this.getPreviousStep(this.currentStep.Id);

        // this._showSMSDialog = (localStorage.getItem('smsDialog') == 'true');
    }

    saveEncryptedIdService(value: string) {
        this.encryptedIdService = value;
    }

    validateServiceNumber(svcId) {
        if (svcId) {
            const svcNumber = typeof svcId !== 'string' ? svcId.toString() : svcId;
            this.showSuccessPage = false;
            localStorage.setItem('IdServicio', svcNumber);
        }
    }

    PreviousSection() {
        this.currentStep = this.getPreviousStep(this.currentStep.Id);
        this.prevStep = this.getPreviousStep(this.currentStep.Id);
        localStorage.setItem('currentStep', JSON.stringify(this.currentStep));
        this.router.navigate([this.currentStep.url]);
    }

    GoToLastSection() {
        this.currentStep = this.getStep(Pages.TAKEN_SERVICE);
        this.router.navigate([this.currentStep.url]);
    }

    NextSection() {
        if (localStorage.getItem('IdServicio') && this.GetAccessToken()) {
            const idPage = this.showSuccessPage ? Pages.SERVICE_SUCCESS : Pages.TAKEN_SERVICE;
            this.currentStep = this.getStep(idPage);
        }
        else {
            this.prevStep = this.currentStep;
            this.currentStep = this.getNextStep(this.currentStep.Id);
        }
        localStorage.setItem('currentStep', JSON.stringify(this.currentStep));

        if (this.currentStep.Id === Pages.TAKEN_SERVICE) {
            this.router.navigate([this.currentStep.url, this.encryptedIdService]);
        } else {
            this.router.navigate([this.currentStep.url]);
        }
    }

    Reset() {
        this.clearStorage();
        this.steps.forEach(x => x.sectionData = new SectionData());
        this.prevStep = null;
        this.currentStep = this.getStep(Pages.LOGIN);
        this.DeactivateSteps(Pages.SECURITY_QUESTIONS_1, Pages.SECURITY_QUESTIONS_2, Pages.DESTINATION_MAP, Pages.SERVICE_DETAILS, Pages.DIMENSION_PICKUP, Pages.DIMENSION_VEHICLE);
        this.DisableLoadingSpinner();
        this.router.navigate([this.currentStep.url]);
    }

    clearStorage() {
        localStorage.removeItem('steps');
        localStorage.removeItem('currentSection');
        localStorage.removeItem('currentStep');
        localStorage.removeItem('prevStep');
        localStorage.removeItem('IdServicio');
        localStorage.removeItem('StandardQueryEncripted');
        localStorage.removeItem('access_token');
        localStorage.removeItem('smsDialog');
    }

    ActivateSteps(...pages) {
        pages.forEach(page => {
            this.getStep(page).active = true;
        });
    }

    DeactivateSteps(...pages) {
        pages.forEach(page => {
            this.getStep(page).active = false;
        });
    }

    ShowAdditionalCostsDialog(costs: string[]) {

        const contactPageLoaded = this.getStep(Pages.CONTACTS);
        const contactPhone = contactPageLoaded && !contactPageLoaded.sectionData.IsEmpty() ? contactPageLoaded.sectionData.GetProperty('telephones')[0] : {};

        const dialogRef = this.dialog.open(AdditionalCostDialogComponent, {
            width: '400px',
            data: {
                contactPhone: contactPhone,
                additionalCosts: costs
            }
        });

        dialogRef.afterClosed().subscribe(phone => {
            if (phone && phone.Code && phone.Number) {
                this.EnableLoadingSpinner();

                this.dataDialogService.sendContactSMS(this.SendSMSData(`${phone.Code}${phone.Number}`)).subscribe(() => {
                    this.DisableLoadingSpinner();
                    const confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                        width: '400px'
                    });

                    confirmDialogRef.afterClosed().subscribe(() => {
                        this.Reset();
                    });
                }, () => {
                    this.DisableLoadingSpinner();
                });

            }

        });
    }

    OpenContactDialog() {
        // Send user action.
        const plate = this.getStep(Pages.LOGIN).sectionData.GetProperty('patente');
        this.summaryService.TrackUsersActions(ActionsTypeEnum.BlockWithConditions, undefined, plate).subscribe(() => { });

        const contactPageLoaded = this.getStep(Pages.CONTACTS);
        const contactPhone = contactPageLoaded && !contactPageLoaded.sectionData.IsEmpty() ? contactPageLoaded.sectionData.GetProperty('telephones')[0] : {};

        const dialogRef = this.dialog.open(DataDialogComponent, {
            width: '400px',
            data: {
                contactPhone: contactPhone
            }
        });

        dialogRef.afterClosed().subscribe(phone => {

            if (phone && phone.Code && phone.Number) {
                this.EnableLoadingSpinner();

                this.dataDialogService.sendContactSMS(this.SendSMSData(`${phone.Code}${phone.Number}`)).subscribe(() => {
                    this.DisableLoadingSpinner();
                    const confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                        width: '400px'
                    });

                    confirmDialogRef.afterClosed().subscribe(() => {
                        this.Reset();
                    });
                }, () => {
                    this.DisableLoadingSpinner();
                });
            }

        });
    }

    OpenCustomDialog(title: string, message: string) {
        this.dialog.open(CustomDialogComponent, {
            width: '400px',
            data: {
                'title': title,
                'message': message
            }
        });
    }

    GetAppQuestionsData(): AppQuestionData[] {
        let saveRequestData: AppQuestionData[] = [];

        this.steps.forEach(step => {
            if (step.active && step.sectionData && !this.stepsToIgnoreOnSave(step.Id)) {
                const questions = step.sectionData.GetAppQuestionData();
                if (questions && questions.length) {
                    saveRequestData = [...saveRequestData, ...questions];
                }
            }
        });

        return saveRequestData;
    }
    /**
     * This is because exists validation steps that have information updated.
     * Return true if the step must be ignore.
     */
    private stepsToIgnoreOnSave(stepId): boolean {
        return stepId === Pages.ORIGIN_MAP || stepId === Pages.DESTINATION_MAP;
    }

    GetResume(): Map<number, string> {
        let resumeData = new Map<number, string>();

        this.steps.forEach(step => {
            if (step.active && step.sectionData) {
                const resume = step.sectionData.GetResume();
                if (resume && resume.size > 0) {
                    resumeData = new Map([...resumeData, ...resume]);
                }
            }
        });

        return resumeData;
    }

    SendWhatsappMessage(message: any) {
        const urlWhatsapp = 'https://wa.me/5491128080012?text=' + encodeURI(message);
        window.open(urlWhatsapp, '_blank');
    }

    EnableLoadingSpinner() {
        this.loading = true;
    }

    DisableLoadingSpinner() {
        this.loading = false;
    }

    GetAccessToken() {
        return localStorage.getItem('access_token');
    }

    private fetchData() {
        this.steps = worklowData;
        this.clearStorage();
        this.prevStep = null;
        this.currentStep = this.getStep(Pages.LOGIN);
    }

    getStep(idPage: number) {
        return this.steps.find(x => x.Id === idPage);
     }

    private getNextStep(currentId: number): Step {
        const idx = this.steps.findIndex(x => x.Id === currentId);
        return this.steps.find((x, index) => index > idx && x.active);
    }

    private getPreviousStep(currentId: number): Step {
        const idx = this.steps.findIndex(x => x.Id == currentId);
        return this.steps.slice(0, idx).reverse().find(x => x.active);
    }

    private SendSMSData(contactPhone: string): AppQuestionData[] {
        let questions = this.GetAppQuestionsData();
        let contactQuestionData: AppQuestionData = questions.find(x => x.IdRepresentative === Representatives.PhoneNumber);
        if (contactQuestionData) {
            contactQuestionData.Value = contactPhone;
        }
        else {
            questions.push({
                IdRepresentative: Representatives.PhoneNumber,
                Value: contactPhone,
                IdDataValueType: DataValueType.Integer,
                Order: 1,
                IdParameter: 0,
                ResponseDateTime: (new Date()).toISOString()
            });
        }
        return questions;
    }

    public get nextLocked(): boolean {
        return this._nextLocked;
    }

    public DisableNext() {
        this._nextLocked = true;
    }

    public EnableNext() {
        this._nextLocked = false;
    }

    getLayoutStylesEvent(): Observable<HbfStylesModel> {
        return this.layoutStyles.asObservable();
    }

    setLayoutStylesEvent(object: HbfStylesModel): void {
        this.layoutStyles.next(object);
    }

    emitServiceState(serviceState: number) {
        this.serviceState.next(serviceState);
    }
}
